export enum ProcessesViewType {
  MY,
  APPROVER,
  OPERATOR
}
